// Lib
import { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Selectors
import { getBoardSummariesArraySelector } from '../../../../element/board/summary/boardSummariesSelector';

// Utils
import { reindexBoardSummariesForSearch } from '../../../../components/search/contentSearch/quickSearch';

const mapStateToProps = (state) => ({
    boardSummaries: getBoardSummariesArraySelector(state),
});

const SearchIndexObserver = ({ boardSummaries }) => {
    useEffect(() => {
        reindexBoardSummariesForSearch(boardSummaries);
    }, [boardSummaries]);

    return null;
};

SearchIndexObserver.propTypes = {
    boardSummaries: PropTypes.array,
};

export default connect(mapStateToProps)(SearchIndexObserver);
